<template>
<b-overlay
    :show="processing"
    rounded="sm"
>

  <template v-slot:overlay>
    <div
        v-if="processing"
        class="text-center p-4 bg-primary text-light rounded"
    >
      <b-icon
          icon="cloud-upload"
          font-scale="4"
      />
      <div class="mb-3">
        منتظر بمانید ...
      </div>
      <b-progress
          min="1"
          max="60"
          :value="counter"
          variant="success"
          height="3px"
          class="mx-n4 rounded-0"
      />
    </div>
  </template>

  <b-card
      title="مدیریت رژیم ها"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
                <b-button
                    class="mb-1 mr-auto ml-1"
                    variant="primary"
                    :to="{name:'addDedicatedDietRegime'}"
                >
                  جدید
                </b-button>
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
                <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    class="mb-1 mr-1"
                    variant="warning"
                    @click="update(1)"
                >فیلتر
                </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2"
            responsive
            :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                :to="{name:'addDedicatedDietRegime' ,params: {regimeId:data.item.Id} } "
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>
          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <b-link :to="{name:'addDedicatedDietRegime',params:{regimeId:data.item.Id , clone:'clone'}}">
                <feather-icon
                    icon="CopyIcon"
                    size="16"
                />
              </b-link>

              <feather-icon
                  icon="FileTextIcon"
                  size="16"
                  class="ml-1"
                  @click="exportExcel(data.item.Id)"
              />
              <b-link :to="{name:'addDedicatedDietRegime' ,params: {regimeId:data.item.Id} } ">
                <feather-icon
                    icon="EditIcon"
                    size="16"
                    class="ml-1"
                />
              </b-link>
              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #cell(SpecialDietCalorie)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(SpecialDietFoodMeal)="data">
            <span
                v-for="(item, index) in data.value"
                :key="index"
            >
              <b-badge
                  style="line-height: unset; margin: 2px;"
                  variant="info"
              >
                {{ item.Title }}
              </b-badge>
            </span>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>
  </b-card>
</b-overlay>
</template>
<script>

import { BIcon, BIconArchiveFill, BIconArchive } from 'bootstrap-vue'

export default {
  name: 'ListDedicatedDiet',
  components: { BIcon, BIconArchiveFill, BIconArchive },
  data() {
    return {
      loading: false,
      processing: false,
      editCalorie: false,
      counter: 1,
      filterOptions: {
        Page: 1,
        Title: '',
        PerPage: 10,
      },
      form: {
        Title: null,
        MaxCalorie: null,
        MinCalorie: null,
      },
      totalRows: null,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'SpecialDietCalorie',
          label: 'کالری',
        },
        {
          key: 'SpecialDietFoodMeal',
          label: 'وعده',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      showModal: false,
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })
      this.$http.post(this.$api.dedicatedDietList.getlist, this.filterOptions).then(res => {
        this.items = res.data
        this.totalRows = res.totalRow
      }).finally(() => {
        this.loading = false
      })
    },
    save() {
      let url
      if (this.editCalorie) url = this.$api.dedicatedDietList.update
      else url = this.$api.dedicatedDietList.add
      this.$http.post(url, this.form).then(() => this.update())
    },
    remove(id) {
      this.removeRow(this.$api.dedicatedDietList.remove, 'Id', id)
    },
    exportExcel(id){

      var This = this

      This.counter = 1
      This.processing = true

      let interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      let filename = id + '.xlsx'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {

          let remaining = 60  - This.counter

          let interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {

            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval)
            clearInterval(interval2)
            This.processing = false

          },remaining * 100)
        }
      }
      xmlHttpRequest.open("POST", '/api/specialdiet/export-excel')
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send(JSON.stringify({
        'Id': id
      }))
    },
  },
}
</script>

<style scoped>

</style>
